import { Input } from "@/components/ui/input";

const SEL = "h-11 w-full rounded-md border border-input bg-transparent px-3 text-sm";
const CHARGEABLE = ["revision", "mant_preventivo", "diagnostico", "visita"];
const F = ({ label, children, className = "" }) => (
  <label className={`block space-y-1.5 ${className}`}><span className="text-xs uppercase tracking-wider text-muted-foreground">{label}</span>{children}</label>
);
const Box = ({ title, children, testid }) => (
  <div className="space-y-3 rounded-lg border border-border p-4" data-testid={testid}><div className="font-mono text-[11px] uppercase tracking-[0.2em] text-primary">{title}</div>{children}</div>
);

const Origin = ({ v, onChange }) => {
  const set = (k, x) => onChange({ doc_type: "", folio: "", date: "", payment_status: "anticipo", ...(v || {}), [k]: x });
  return (
    <Box title="Origen comercial" testid="wo-commercial-origin">
      <div className="grid gap-3 sm:grid-cols-4">
        <F label="Tipo de documento"><select className={SEL} value={v?.doc_type || ""} onChange={(e) => (e.target.value ? set("doc_type", e.target.value) : onChange(null))} data-testid="wo-origin-doc-type">
          <option value="">Sin documento</option><option value="pedido">Pedido</option><option value="nota_venta">Nota de venta</option><option value="factura">Factura</option></select></F>
        <F label="Folio del documento"><Input className="h-11" value={v?.folio || ""} disabled={!v?.doc_type} onChange={(e) => set("folio", e.target.value)} data-testid="wo-origin-folio" /></F>
        <F label="Fecha"><Input className="h-11" type="date" value={v?.date || ""} disabled={!v?.doc_type} onChange={(e) => set("date", e.target.value)} data-testid="wo-origin-date" /></F>
        <F label="Pago"><select className={SEL} value={v?.payment_status || "anticipo"} disabled={!v?.doc_type} onChange={(e) => set("payment_status", e.target.value)} data-testid="wo-origin-payment">
          <option value="anticipo">Anticipo recibido</option><option value="pago_completo">Pago completo recibido</option></select></F>
      </div>
    </Box>
  );
};

const Charge = ({ v, onChange }) => {
  const c = v || { chargeable: false, amount: null, notes: "" };
  const set = (k, x) => onChange({ ...c, [k]: x });
  return (
    <Box title="Cobro al cliente" testid="wo-client-charge">
      <div className="grid gap-3 sm:grid-cols-3">
        <F label="Cobrable"><select className={SEL} value={c.chargeable ? "1" : ""} onChange={(e) => set("chargeable", !!e.target.value)} data-testid="wo-charge-chargeable"><option value="">No</option><option value="1">Sí</option></select></F>
        <F label="Tarifa a cobrar al cliente"><Input className="h-11" type="number" min="0" value={c.amount ?? ""} disabled={!c.chargeable} onChange={(e) => set("amount", e.target.value === "" ? null : Number(e.target.value))} data-testid="wo-charge-amount" /></F>
        <F label="Observación"><Input className="h-11" value={c.notes || ""} onChange={(e) => set("notes", e.target.value)} data-testid="wo-charge-notes" /></F>
      </div>
    </Box>
  );
};

const Travel = ({ v, onChange }) => {
  const t = v || { required: false, concept: "", amount: null, mode: "reembolso", notes: "" };
  const set = (k, x) => onChange({ ...t, [k]: x });
  return (
    <Box title="Viáticos (autoriza Supervisión)" testid="wo-travel-expenses">
      <div className="grid gap-3 sm:grid-cols-4">
        <F label="Requiere viáticos"><select className={SEL} value={t.required ? "1" : ""} onChange={(e) => set("required", !!e.target.value)} data-testid="wo-travel-required"><option value="">No</option><option value="1">Sí</option></select></F>
        <F label="Concepto"><Input className="h-11" value={t.concept || ""} disabled={!t.required} onChange={(e) => set("concept", e.target.value)} data-testid="wo-travel-concept" /></F>
        <F label="Importe"><Input className="h-11" type="number" min="0" value={t.amount ?? ""} disabled={!t.required} onChange={(e) => set("amount", e.target.value === "" ? null : Number(e.target.value))} data-testid="wo-travel-amount" /></F>
        <F label="Modalidad"><select className={SEL} value={t.mode} disabled={!t.required} onChange={(e) => set("mode", e.target.value)} data-testid="wo-travel-mode"><option value="anticipo">Anticipo</option><option value="reembolso">Reembolso</option></select></F>
        <F label="Observación" className="sm:col-span-4"><Input className="h-11" value={t.notes || ""} onChange={(e) => set("notes", e.target.value)} data-testid="wo-travel-notes" /></F>
      </div>
      {t.authorized_by_name && <p className="text-xs text-muted-foreground" data-testid="wo-travel-authorized">Autorizado por {t.authorized_by_name}</p>}
    </Box>
  );
};

export const FinanceSections = ({ f, set }) => (
  <div className="space-y-4" data-testid="wo-finance-sections">
    <Origin v={f.commercial_origin} onChange={(v) => set("commercial_origin", v)} />
    {CHARGEABLE.includes(f.service_type_code) && <Charge v={f.client_charge} onChange={(v) => set("client_charge", v)} />}
    <Travel v={f.travel_expenses} onChange={(v) => set("travel_expenses", v)} />
  </div>
);
